import script from "./NewsCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsCenter.vue?vue&type=script&setup=true&lang=js"

import "./NewsCenter.vue?vue&type=style&index=0&id=17422b40&scoped=true&lang=css"
import "./NewsCenter.vue?vue&type=style&index=1&id=17422b40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17422b40"]])

export default __exports__